import { ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import { bonoPosventaBackgroundColor } from '../../../../../../helpers/color-tokens';
import { HuchaPosventaValues } from '../../../shared/models/hucha-values';
import { BonoCardBackground } from '../../../shared/ui/bono-card-backgound';
import { HuchaCol } from '../../../shared/ui/layout-composition';
import { BonoPosventaCardC1 } from './bono-posventa-card-c1';
import { BonoPosventaCardC2 } from './bono-posventa-card-c2';

export const BonoPosventaCard = ({ huchaValues }: { huchaValues: HuchaPosventaValues }) => {
	return (
		<BonoCardBackground
			bgColor={bonoPosventaBackgroundColor}
			stretchContent
			data-testid="bono-posventa-card-container"
			wrap={'never'}
		>
			<ThemeProvider theme={'inverted'}>
				<HuchaCol $bonoPosventaExists={true}>
					<BonoPosventaCardC1 huchaValues={huchaValues} />
					<BonoPosventaCardC2 dineroHucha={huchaValues.dineroHucha} />
				</HuchaCol>
			</ThemeProvider>
		</BonoCardBackground>
	);
};
